<script lang="ts">
  import clsx from 'clsx'
  import captionsState from '../../../stores/captions.svelte'
  import translationsStore from '../../../stores/translations.svelte'
  import videoStore from '../../../stores/video.svelte'
  import SettingsIcon from '../icons/SettingsIcon.svelte'
  import SettingsMenu from '../settings-menu/SettingsMenu.svelte'
  import ControlBarButton from './ControlBarButton.svelte'

  let hasSettings = $derived(
    captionsState.state.subtitleTracks.length || !videoStore.isLiveStream(),
  )

  function close() {
    videoStore.state.settingsMenuOpen = false
  }
</script>

<ControlBarButton
  tooltip={translationsStore.state.settings}
  id="settings-button"
  onclick={() =>
    (videoStore.state.settingsMenuOpen = !videoStore.state.settingsMenuOpen)}
  hidden={!hasSettings || videoStore.state.isChromecasting}
>
  <div
    class={clsx(
      'transform duration-200 ease-in-out transition-transform',
      videoStore.state.settingsMenuOpen && 'rotate-[60deg]',
    )}
  >
    <SettingsIcon />
  </div>
</ControlBarButton>
{#if videoStore.state.settingsMenuOpen}
  <SettingsMenu onclose={() => close()} />
{/if}
